// Vendors
import {
  LoaderComponent,
  ParagraphComponent,
  TitleComponent,
} from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import {
  LOADING_COMPONENT_LOADER_PROPS,
  LOADING_COMPONENT_TITLE_PROPS,
} from './constants/loading.constants';
// Styles
import {
  LoadingComponentStyled,
  LoadingBottomSideComponentStyled,
  LoadingBottomSideTitleComponentStyled,
} from './loading.component.styled';
// Types
import { LoadingType } from './types/loading.type';

const LoadingComponent = ({
  children,
  description,
  fetching,
  title,
}: LoadingType): React.JSX.Element =>
  fetching ? (
    <LoadingComponentStyled>
      <LoaderComponent {...LOADING_COMPONENT_LOADER_PROPS} />
      <LoadingBottomSideComponentStyled>
        <LoadingBottomSideTitleComponentStyled>
          <TitleComponent
            {...LOADING_COMPONENT_TITLE_PROPS}
            title={<FormattedMessage id={title} />}
          />
        </LoadingBottomSideTitleComponentStyled>
        <ParagraphComponent>
          <FormattedMessage id={description} />
        </ParagraphComponent>
      </LoadingBottomSideComponentStyled>
    </LoadingComponentStyled>
  ) : (
    <>{children}</>
  );

export { LoadingComponent };
